/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { SPARKLE_ANIMATION_KEY } from './gameData';
import UIAssetKeys from './UIAssetKeys';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  fixPivot(mainTex, CAT_ANIMATION_DATA.key, CAT_ANIMATION_DATA.frames);
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 */
export function addAllCatAnimationToSprite(sprite, play = true) {
  const animationData = CAT_ANIMATION_DATA;
  const animationKey = 'all';
  const animationFramesData = animationData.animations.all;
  if (animationFramesData.frames.length === 1) {
    sprite.stop();

    // this animation only has 1 frame, just set it
    sprite.setFrame(`${CAT_ANIMATION_DATA.key}${animationFramesData.frames[0]}`);
    return;
  }
  if (sprite.anims.exists(animationKey)) {
    if (play) sprite.play(animationKey);
    return;
  }

  const frames = [];
  animationFramesData.frames.forEach(frameNum => frames.push({ frame: `${CAT_ANIMATION_DATA.key}${frameNum.toString()}` }));
  sprite.anims.create(
    {
      defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
      frameRate: (animationFramesData.framerate ?? 24) / animationFramesData.speed,
      key: animationKey,
      frames
    }
  );

  sprite.on(`${Phaser.Animations.Events.ANIMATION_COMPLETE_KEY}start`, () => {
    sprite.setFrame(`${CAT_ANIMATION_DATA.key}${animationData.animations[animationFramesData.next].frames[0]}`);
  });
  if (play) sprite.play(animationKey);
}


// this data comes from the original game; this is the CreateJs sprite sheet animation export
export const CAT_ANIMATION_DATA = {
  key: 'cat/',
  frames: [
    [0, 0, 256, 256, 0, -2, -68],
    [256, 0, 256, 256, 0, -2, -68],
    [512, 0, 256, 256, 0, -2, -68],
    [768, 0, 256, 256, 0, -2, -68],
    [1024, 0, 256, 256, 0, -2, -68],
    [1280, 0, 256, 256, 0, -2, -68],
    [1536, 0, 256, 256, 0, -2, -68],
    [0, 256, 256, 256, 0, -2, -68],
    [256, 256, 256, 256, 0, -2, -68],
    [512, 256, 256, 256, 0, -2, -68],
    [768, 256, 256, 256, 0, -2, -68],
    [1024, 256, 256, 256, 0, -2, -68],
    [1280, 256, 256, 256, 0, -2, -68],
    [1536, 256, 256, 256, 0, -2, -68],
    [0, 512, 256, 256, 0, -2, -68],
    [256, 512, 256, 256, 0, -2, -68],
    [512, 512, 256, 256, 0, -2, -68],
    [768, 512, 256, 256, 0, -2, -68],
    [1024, 512, 256, 256, 0, -2, -68],
    [1280, 512, 256, 256, 0, -2, -68],
    [1536, 512, 256, 256, 0, -2, -68],
    [0, 768, 256, 256, 0, -2, -68],
    [256, 768, 256, 256, 0, -2, -68],
    [512, 768, 256, 256, 0, -2, -68],
    [768, 768, 256, 256, 0, -2, -68],
    [1024, 768, 256, 256, 0, -2, -68],
    [1280, 768, 256, 256, 0, -2, -68],
    [1536, 768, 256, 256, 0, -2, -68],
    [0, 1024, 256, 256, 0, -2, -68],
    [256, 1024, 256, 256, 0, -2, -68],
    [512, 1024, 256, 256, 0, -2, -68],
    [768, 1024, 256, 256, 0, -2, -68],
    [1024, 1024, 256, 256, 0, -2, -68],
    [1280, 1024, 256, 256, 0, -2, -68],
    [1536, 1024, 256, 256, 0, -2, -68],
    [0, 1280, 256, 256, 0, -2, -68],
    [256, 1280, 256, 256, 0, -2, -68],
    [512, 1280, 256, 256, 0, -2, -68],
    [768, 1280, 256, 256, 0, -2, -68],
    [1024, 1280, 256, 256, 0, -2, -68],
    [1280, 1280, 256, 256, 0, -2, -68],
    [1536, 1280, 256, 256, 0, -2, -68],
    [0, 1536, 256, 256, 0, -2, -68],
    [256, 1536, 256, 256, 0, -2, -68],
    [512, 1536, 256, 256, 0, -2, -68],
    [768, 1536, 256, 256, 0, -2, -68],
    [1024, 1536, 256, 256, 0, -2, -68],
    [1280, 1536, 256, 256, 0, -2, -68],
    [1536, 1536, 256, 256, 0, -2, -68],
    [0, 1792, 256, 256, 0, -2, -68],
    [256, 1792, 256, 256, 0, -2, -68],
    [512, 1792, 256, 256, 0, -2, -68],
    [768, 1792, 256, 256, 0, -2, -68],
    [1024, 1792, 256, 256, 0, -2, -68],
    [1280, 1792, 256, 256, 0, -2, -68],
    [1536, 1792, 256, 256, 0, -2, -68],
    [0, 0, 256, 256, 1, -2, -68],
    [256, 0, 256, 256, 1, -2, -68],
    [512, 0, 256, 256, 1, -2, -68],
    [768, 0, 256, 256, 1, -2, -68],
    [1024, 0, 256, 256, 1, -2, -68],
    [1280, 0, 256, 256, 1, -2, -68],
    [1536, 0, 256, 256, 1, -2, -68],
    [0, 256, 256, 256, 1, -2, -68],
    [256, 256, 256, 256, 1, -2, -68],
    [512, 256, 256, 256, 1, -2, -68],
    [768, 256, 256, 256, 1, -2, -68],
    [1024, 256, 256, 256, 1, -2, -68],
    [1280, 256, 256, 256, 1, -2, -68],
    [1536, 256, 256, 256, 1, -2, -68],
    [0, 512, 256, 256, 1, -2, -68],
    [256, 512, 256, 256, 1, -2, -68],
    [512, 512, 256, 256, 1, -2, -68],
    [768, 512, 256, 256, 1, -2, -68],
    [1024, 512, 256, 256, 1, -2, -68],
    [1280, 512, 256, 256, 1, -2, -68],
    [1536, 512, 256, 256, 1, -2, -68],
    [0, 768, 256, 256, 1, -2, -68],
    [256, 768, 256, 256, 1, -2, -68],
    [512, 768, 256, 256, 1, -2, -68],
    [768, 768, 256, 256, 1, -2, -68],
    [1024, 768, 256, 256, 1, -2, -68],
    [1280, 768, 256, 256, 1, -2, -68],
    [1536, 768, 256, 256, 1, -2, -68],
    [0, 1024, 256, 256, 1, -2, -68],
    [256, 1024, 256, 256, 1, -2, -68],
    [512, 1024, 256, 256, 1, -2, -68],
    [768, 1024, 256, 256, 1, -2, -68],
    [1024, 1024, 256, 256, 1, -2, -68],
    [1280, 1024, 256, 256, 1, -2, -68],
    [1536, 1024, 256, 256, 1, -2, -68],
    [0, 1280, 256, 256, 1, -2, -68],
    [256, 1280, 256, 256, 1, -2, -68],
    [512, 1280, 256, 256, 1, -2, -68],
    [768, 1280, 256, 256, 1, -2, -68],
    [1024, 1280, 256, 256, 1, -2, -68],
    [1280, 1280, 256, 256, 1, -2, -68],
    [1536, 1280, 256, 256, 1, -2, -68],
    [0, 1536, 256, 256, 1, -2, -68],
    [256, 1536, 256, 256, 1, -2, -68],
    [512, 1536, 256, 256, 1, -2, -68],
    [768, 1536, 256, 256, 1, -2, -68],
    [1024, 1536, 256, 256, 1, -2, -68]
  ],
  animations: {
    CrouchBeforeJump: {
      frames: [52, 53, 54, 55, 56, 57, 58, 59, 59, 59, 59],
      speed: 1
    },
    JumpLanding: {
      frames: [
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        54,
        101,
        102
      ],
      speed: 1
    },
    SittingPose: { frames: [0], speed: 1 },
    Stand: { frames: [17], speed: 1 },
    Jump: {
      frames: [
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88
      ],
      speed: 1
    },
    Walk: {
      frames: [
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51
      ],
      speed: 1
    },
    StandingUp: {
      frames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      speed: 1
    },
    all: {
      frames: [0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        57,
        57,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        98,
        99,
        100,
        101],
      next: 'Idle',
      frequency: 1,
      speed: 1

    },
    Idle: { frames: [101], speed: 1 }
  }
};